"use strict";
load.e = exists;
module.exports = load;

function load(id) {
  return interopRequire(require(id));
}

function exists() {
  return false;
}

function interopRequire(mod) {
  return mod.default || mod;
}